import {addLoader, apiSlice, asyncToastDisplay, i18n} from "./apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => (`/users`),
      providesTags: (result , error, arg) => [{ type: 'User', id: "LIST"}],
    }),
    getUser: builder.query({
      query: (userId) => (`/users/${userId}`),
      providesTags: (result , error, userId) => [{ type: 'User', id: userId}],
    }),
    getUserResetPassword: builder.query({
      query: (userId) => (`/users/${userId}/reset_password`),
    }),
    getUserResendConfirmationInstructions: builder.query({
      query: (userId) => (`/users/${userId}/resend_confirmation_instructions`),
    }),
    createUser: builder.mutation({
      query: ({user}) => ({
        url: `/users/`,
        method: 'POST',
        body: user
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [{ type: 'User', id: "LIST"}],
    }),
    updateUser: builder.mutation({
      query: ({user}) => ({
        url: (`/users/${user.userId}`),
        method: 'PUT',
        body: user,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {user}) => [{ type: 'User', id: "LIST"}, { type: 'User', id: user.userId }],
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: (`/users/${userId}`),
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, {userId}) => [{ type: 'User', id: "LIST"}, { type: 'User', id: userId }],
    }),
    getCompanies: builder.query({
      query: () => (`/users/companies`),
      providesTags: (result , error, arg) => [{ type: 'User', id: "Companies"}],
    }),
    getCurrentUser: builder.query({
      query: () => (`/users/current`),
      providesTags: (result , error, arg) => [{ type: 'User', id: "current"}],
      onQueryStarted: addLoader()
    }),
  }),
  overrideExisting: false
})

export const {
  useGetUsersQuery,
  useGetUserQuery,
  useUpdateUserMutation,
  useCreateUserMutation,
  useDeleteUserMutation,
  useGetCompaniesQuery,
  useGetCurrentUserQuery,
  useLazyGetUserResendConfirmationInstructionsQuery,
  useLazyGetUserResetPasswordQuery,
} = userApiSlice
